import React from 'react'
import Layout from '../components/layout'
import { Helmet } from 'react-helmet'

class TermsOfService extends React.Component {
  render() {
    return (
      <Layout>
        <Helmet title="Terms of Service" defer={false} />
        <section className="dib relative w-100 brand-navy lh-copy bg-brand-near-white">
          <div className="center mw8 ph3 ph5-ns pv6 relative">
            <div className="dib relative w-100">
              <div className="db center relative w-100 br3 bg-white shadow-light pa4">
                <h1 className="dib relative w-100 f2 b">TERMS OF SERVICE</h1>
                <h2 className="dib relative w-100 f5 b">
                  Effective Date: July 1, 2019
                </h2>
                <div>
                  <h2 className="dib relative w-100 f3 b">
                    Business with Paytm Terms of Service - Canada
                  </h2>
                  <h2 className="dib relative w-100 f4 b">
                    Required Regulatory Disclosures
                  </h2>
                  <p>
                    We are required by financial regulators to provide to you at
                    the beginning of our agreement a summary of certain
                    information from the agreement and disclosure of our fees.
                    This information is described in more detail in the body of
                    the agreement.
                  </p>
                  <h2 className="dib relative w-100 f4 b">
                    Information Summary Box
                  </h2>
                  <table className="table-doc">
                    <tr>
                      <th className="tg-0lax">Date of contract</th>
                      <th className="tg-0lax">
                        The Agreement is effective upon the date you agree to
                        the terms of service by accepting them electronically
                        and continues as long as you use the Service or until
                        terminated by Paytm Labs.
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Acquirer</th>
                      <th className="tg-0lax">
                        Peoples Trust Company
                        <br />
                        888 Dunsmuir Street, Suite 1400
                        <br />
                        Vancouver, BC, V6C 3K4
                        <br />
                        Tel : 1-844-304-2083
                        <br />
                        <a
                          className="blue"
                          href="mailto:merchantacquiring@peoplestrust.com"
                        >
                          merchantacquiring@peoplestrust.com
                        </a>
                        <br />
                        https://www.peoplescardservices.com
                        <br />
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">
                        Cancellation of contract and applicable penalties
                      </th>
                      <th className="tg-0lax">
                        This agreement can be cancelled at any time without
                        penalty.
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Complaint handling procedures</th>
                      <th className="tg-0lax">
                        If you have a complaint in respect of the Code of
                        Conduct for the Credit and Debit Card Industry in
                        Canada, please contact Paytm at merchantsupport@paytm.ca
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Transaction return policy</th>
                      <th className="tg-0lax">
                        All payment acceptance fees are returned to you when a
                        refund or return is processed.
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Code of Conduct</th>
                      <th className="tg-0lax">
                        The Code of Conduct for the credit and debit card
                        industry can be located at the{' '}
                        <a
                          className="blue"
                          href="https://www.canada.ca/en/financial-consumer-agency/services/industry/laws-regulations/credit-debit-code-conduct.html"
                        >
                          Government of Canada
                        </a>{' '}
                        website.
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">
                        Independent sales organization
                      </th>
                      <th className="tg-0lax">
                        Paysafe Merchant Services Inc.
                        <br />
                        3500 de Maisonneuve Blvd. West., Suite 700
                        <br />
                        Montreal, Québec, H3Z 3C1
                        <br />
                        Tel: 1-888-709-8753
                        <br />
                        complaints@paysafe.com
                        <br />
                        https://processing.paysafe.com/
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Payment facilitator</th>
                      <th className="tg-0lax">
                        Paytm Labs Inc.
                        <br />1 Richmond St. W, Suite 200
                        <br />
                        Toronto, ON, M5H 3W4
                        <br />
                        <a className="blue" href="https://www.paytm.ca/">
                          https://www.paytm.ca/
                        </a>
                        <br />
                        merchantsupport@paytm.ca
                        <br />
                      </th>
                    </tr>
                    <tr>
                      <th className="tg-0lax">Statements</th>
                      <th className="tg-0lax">
                        You can view your transaction history online by logging
                        into your Paytm Labs Sub-Merchant account on our
                        website, free of charge.
                      </th>
                    </tr>
                  </table>
                  <h2 className="dib relative w-100 f4 b">
                    Fee Disclosure Box
                  </h2>
                  <p>
                    <span className="black">Card Not Present</span> means that
                    the card was not electronically read by an electronic card
                    reader and the card information is manually key entered. (
                    <i>e.g.</i> online payment)
                  </p>

                  <table className="table-doc">
                    <tr>
                      <th>Payment Card Type</th>
                      <th>Processing Method: Card Not Present</th>
                    </tr>
                    <tr>
                      <td>Visa Infinite</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Infinite Privilege</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Business</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Infinite Business</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Corporate</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Purchasing</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Prepaid</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa Debit</td>
                      <td>1.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>Visa International Cards</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard Core</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard World</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard World Elite</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard Commercial</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard Debit</td>
                      <td>1.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard Prepaid</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                    <tr>
                      <td>MasterCard International Cards</td>
                      <td>2.75% + CA$0.30</td>
                    </tr>
                  </table>
                </div>
                <div style={{ marginTop: 20 }}>
                  <table className="table-doc">
                    <tr>
                      <th>One-time fees</th>
                      <th>Pricing structure ​</th>
                    </tr>
                    <tr className="table-inside">
                      <td>
                        <tr>
                          <th>​​Application fee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th>​Terminal set up fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​​Inte​rac set up fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​​Merchant ​set up fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Season​al set up fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Seaso​nal activation fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Security set u​p fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>E-comm​erce application fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​E-commer​ce mobile application fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Instal​lation fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Trainin​g fee​ Gatew​ay set up fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Fraud dete​ction set up fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Wirele​ss set up fee​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Softw​are fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Onli​ne set up fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th className="text-bold">​Monthly fees</th>
                        </tr>
                        <tr>
                          <th>​State​ment fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Monthly m​inimum fee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th>​Mon​thly fee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th>​PCI f​ee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th>​Non-co​mpliance security fee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th className="text-bold">​Annual fees</th>
                        </tr>
                        <tr>
                          <th>​Annua​l fee</th>
                          <th>​$0.00</th>
                        </tr>
                        <tr>
                          <th className="text-bold">Transaction fees</th>
                        </tr>
                        <tr>
                          <th>​Visa autho​rization fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​​MasterCard authori​zation fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​Interac author​ization fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​​American Ex​press authorization fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​Visa transac​tion fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​MasterCard tran​saction fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​​Interac trans​action fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​American Expr​ess transaction fee</th>
                          <th>​$0.25</th>
                        </tr>
                        <tr>
                          <th>​Union Pay trans​action fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​​Visa cross-​border rate</th>
                          <th>​​See Note 1</th>
                        </tr>
                        <tr>
                          <th>​​MasterCar​d cross-border fee</th>
                          <th>​​See Note 2</th>
                        </tr>
                        <tr>
                          <th>​Visa assessm​ent rate</th>
                          <th>See Note 1</th>
                        </tr>
                        <tr>
                          <th>​MasterCard asse​ssment rate</th>
                          <th>​See Note 2</th>
                        </tr>
                        <tr>
                          <th>​​International assessment fee</th>
                          <th>N/A</th>
                        </tr>
                      </td>

                      <td>
                        <tr>
                          <th className="text-bold">​​Tier​ed pricing</th>
                        </tr>
                        <tr>
                          <th>Visa i​nterchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Maste​rCard interchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Qual​ified rate​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Mid-qu​alified rate​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Non-qua​lified rate​</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Merc​hant discount rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Inter​ac flat rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th className="text-bold">​​Flat rate</th>
                        </tr>
                        <tr>
                          <th>Visa fl​at rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Mast​erCard flat rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th className="text-bold">Cost p​lus pricing​</th>
                        </tr>
                        <tr>
                          <th>​Fl​at rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Visa inte​rchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>MasterC​ard interchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>Non-quali​fied surcharge rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Interac fla​t rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th className="text-bold">
                            Interc​hange differential rate​
                          </th>
                        </tr>
                        <tr>
                          <th>​Visa inter​change rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Visa appl​icable interchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Interchange differential rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Merchant discount rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Rate adjustment fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​MasterCard interchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​MasterCard applicable interchange rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​​Interchange differential rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Merchant discount rate</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Rate adjustment fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th>​Interac flat fee</th>
                          <th>​N/A</th>
                        </tr>
                        <tr>
                          <th className="text-bold">​Other variable fees</th>
                        </tr>
                        <tr>
                          <th>​Reversal fee</th>
                          <th>​​$0.00</th>
                        </tr>
                        <tr>
                          <th>​Decline fee</th>
                          <th>​​​$25.00</th>
                        </tr>
                        <tr>
                          <th>​Chargeback fee</th>
                          <th>​​​​$25.00</th>
                        </tr>
                        <tr>
                          <th>​Batch fee</th>
                          <th>​​​​$0.15</th>
                        </tr>
                        <tr>
                          <th>​Interac debit surcharge</th>
                          <th>​​​​N/A</th>
                        </tr>
                        <tr>
                          <th>​Interac debit monthly minimum</th>
                          <th>​​​​N/A</th>
                        </tr>
                        <tr>
                          <th>​Online/Web reporting fee</th>
                          <th>​​​​N/A</th>
                        </tr>
                        <tr>
                          <th>​Voice authorization</th>
                          <th>​​​​N/A</th>
                        </tr>
                      </td>
                    </tr>
                  </table>
                </div>

                <p>
                  Note 1:{' '}
                  <a
                    className="blue"
                    href="https://www.visa.ca/en_CA/support/small-business/interchange.html"
                  >
                    https://www.visa.ca/en_CA/support/small-business/interchange.html
                  </a>
                  <br />
                  Note 2:{' '}
                  <a
                    className="blue"
                    href="https://www.mastercard.ca/en-ca/merchants.html"
                  >
                    https://www.mastercard.ca/en-ca/merchants.html
                  </a>
                </p>

                <p>
                  Business with Paytm Terms of Service - Canada (this
                  “Agreement”) constitutes a legal agreement between you
                  (“Merchant”, “User,” “You” or “Your”) and Paytm Labs Inc.
                  (“Paytm Labs” “Paytm,” “We,” “Our” or “Us”) and governs Your
                  access to and use of Paytm Labs’ merchant payment processing
                  services (the “Service” or “Business with Paytm”). To use the
                  Service, you must agree to all the terms of this Agreement.
                  “You” includes the business registering for the Service, the
                  business owner or principal and the individual registering the
                  business for the Service.
                </p>
                <p>
                  This Agreement is in addition to Paytm Labs’ Merchant Services
                  Terms of Use (“Paytm Labs TOU”) which govern the use of the
                  Paytm Merchant Services website and Paytm’s privacy policy
                  available by clicking “Privacy Policy” hyperlink at the bottom
                  of the Paytm Merchant Services Website (“Privacy Policy”),
                  both of which also apply to Your Business with Paytm. To the
                  extent there is any conflict between the Paytm Labs TOU and
                  this Agreement, the terms of this Agreement shall prevail only
                  with respect to Business with Paytm. Capitalized terms not
                  expressly defined in this Agreement have the meaning given to
                  them in the Paytm Labs TOU.
                </p>
                <p>
                  PLEASE READ THIS AGREEMENT AND THE PAYTM LABS TOU CAREFULLY
                  BEFORE USING OR ACCESSING THE SERVICE. EACH TIME YOU USE THE
                  SERVICE, YOUR USE INDICATES YOUR FULL ACCEPTANCE OF AND
                  AGREEMENT TO ABIDE BY THIS AGREEMENT AND THE PAYTM LABS TOU IN
                  THEIR THEN CURRENT FORM. IF YOU DO NOT ACCEPT THE TERMS AND
                  CONDITIONS IN THIS AGREEMENT AND THE PAYTM LABS TOU, DO NOT
                  USE OR ACCESS BUSINESS WITH PAYTM. YOUR CONTINUED USE OF
                  AND/OR ACCESS TO THE SERVICE WILL BE DEEMED YOUR CONCLUSIVE
                  ACCEPTANCE OF THE THEN-CURRENT VERSION OF THIS AGREEMENT AND
                  THE PAYTM LABS TOU.
                </p>
                <p>
                  If at any time you do not, cannot or no longer wish to comply
                  with this Agreement and/or the Paytm Labs TOU, your sole and
                  exclusive remedy is to discontinue using and/or accessing the
                  Service, and you shall have no other recourse or remedy
                  against Paytm Labs or any of its employees, agents or
                  representatives. By using the Service, you agree to be bound
                  by the terms and conditions of this Agreement. Your failure to
                  comply with these terms and conditions may result in immediate
                  suspension or termination, or both, of Business with Paytm
                  and/or any other Service(s).
                </p>
                <h2 className="dib relative w-100 f3 b">
                  A. Business with Paytm Service
                </h2>
                <p>
                  This Service allows you to accept payments initiated with
                  credit cards or debit cards bearing the trademarks of Visa,
                  MasterCard or Interac or other credit or debit card networks
                  (collectively, the “Networks”). These transactions are between
                  you and the people who pay you (“Customers”).
                </p>
                <p>
                  To facilitate your receipt of payment, Paytm Labs initiates
                  the payment process by providing information to a third-party
                  payment processor (the “Payment Processor”). The Payment
                  Processor relays information to a bank (the “Bank”), that is a
                  member of the Networks. Paytm Labs is not a Bank or a Payment
                  Processor. Our obligation to pay you as the Merchant is
                  subject to:
                </p>
                <ol className="list-iems-doc" type="A">
                  <li>
                    the provisions of our agreement with the Bank and/or Payment
                    Processor; and
                  </li>
                  <li>
                    the “Operating Regulations” of the particular Network.
                  </li>
                </ol>
                <h2 className="dib relative w-100 f3 b">
                  B. Registration and Account
                </h2>
                <h3 className="dib relative w-100 f4 b">Registration</h3>
                <p>
                  The Service is offered to persons in Canada operating a
                  business selling goods or services. To use the Service, you
                  must register with Paytm Labs to create a Business with Paytm
                  account (the “Paytm Payment Account”) and you must be at least
                  the age of majority in the Canadian province or territory in
                  which you reside at the time you register. You may register as
                  an individual (sole proprietor) or as a company or other
                  business entity. If you register as a company or other
                  business entity, you must provide information about the
                  business, as well as information about an owner or principal
                  of the business and you (meaning the individual registering)
                  must be authorized to act on behalf of the business. By
                  registering for a Paytm Labs Account, you represent and
                  warrant that you are registering on your own behalf, or that
                  you are registering on behalf of a business or nonprofit
                  organization and you have the authority to enter into this
                  agreement on its behalf. Your acceptance of this Agreement
                  constitutes acceptance by the business or nonprofit
                  organization.
                </p>
                <p>
                  During the registration process, Paytm Labs collects
                  information about the business owner, including (at a minimum)
                  their:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>Name,</li>
                  <li>Address,</li>
                  <li>Date of birth,</li>
                  <li>Social Insurance Number (optional),</li>
                  <li>Business name,</li>
                  <li>Business number,</li>
                  <li>Telephone number, and</li>
                  <li>Website</li>
                </ol>
                <p>
                  Paytm Labs may request supplemental documentation for identity
                  verification at any time and you agree to provide said
                  documentation upon request. This documentation may include,
                  but is not limited to:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>
                    a government-issued identification (such as a passport or
                    driver’s license),
                  </li>
                  <li>business licence</li>
                  <li>articles of incorporation</li>
                </ol>
                <p>
                  We may also require additional information for underwriting
                  and other purposes as set forth below.
                </p>
                <h3 className="dib relative w-100 f4 b">Location</h3>
                <p>
                  Only Canadian businesses (including sole proprietors) and
                  nonprofit organizations may register for the Service. You must
                  be either:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>Canadian citizen</li>
                  <li>a legal permanent resident of Canada, or</li>
                  <li>
                    an authorized Canadian business or non-profit organization
                    having a physical presence in Canada.
                  </li>
                </ol>
                <p>
                  Each Paytm Payment Account requires a valid Canadian bank
                  account.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Verification & Accuracy
                </h3>
                <p>
                  You must provide accurate and complete information. If we
                  cannot verify that the information you provide is complete and
                  accurate, we may deny your use of the Service, or close your
                  Paytm Payment Account. You agree to immediately notify us if
                  you discover that any information which you provided to us is
                  inaccurate or out of date and to immediately correct and
                  update all such information as necessary from time to time.
                </p>
                <p>
                  You authorize Paytm Labs, directly or through inquiry of third
                  parties, to verify the accuracy of any information you
                  provide. If you are a business owner or principal of the
                  business registering, you authorize Paytm Labs, directly or
                  through inquiry of third parties, to obtain a consumer report
                  on you from a consumer reporting agency. We may periodically
                  obtain additional credit reports to determine whether you
                  continue to meet the requirements for the Service.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Underwriting and Sharing Information
                </h3>
                <p>
                  Paytm Labs may share some or all of the information about you,
                  your website and business, your use of this Service and your
                  transactions with our service providers (and their respective
                  affiliates, agents, subcontractors, and employees, as
                  necessary), in order to create your Paytm Payment Account and
                  complete our onboarding and KYC processes, to perform
                  analytics and create reports, to prevent fraud, and for any
                  other lawful purpose. You agree that Paytm Labs and its
                  service providers (and their respective affiliates, agents,
                  subcontractors and employees, as necessary) are permitted to
                  conduct monitoring of your Merchant website and payment
                  transactions for the purposes of security, fraud prevention,
                  information validation, compliance and integrity monitoring.
                  The Networks may use your name, address, and website address
                  (URL) in any media from time to time in lists of Merchants
                  published by the Networks. At any time, Paytm Labs, its
                  processor or its other partners may conclude that you will not
                  be permitted to use the Service.
                </p>
                <p>
                  You agree that Paytm Labs is permitted to contact banks and
                  other financial institutions, your Customers or your
                  Customer’s bank and obtain information, as permitted by
                  applicable law, about the business registering for the
                  Service, the business owners or principals and accounts held
                  by the business, business owners or principals. Paytm Labs is
                  also permitted to share information about you in accordance
                  with our Privacy Policy. This includes sharing information:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>for regulatory or compliance purposes,</li>
                  <li>
                    for use in connection with the management and maintenance of
                    the Service,
                  </li>
                  <li>
                    for the maintenance of customer records about you and to
                    assist us in better serving you, and
                  </li>
                  <li>to conduct Paytm Labs' risk management process</li>
                </ol>
                <h2 className="dib relative w-100 f3 b">
                  C. Accounts and Fees
                </h2>
                <h3 className="dib relative w-100 f4 b">Settlement Account</h3>
                <p>
                  By agreeing to this Agreement, you authorize us to hold,
                  receive, and disburse funds on your behalf. You authorize
                  Paytm Labs to instruct the Bank on the manner in which your
                  card transaction settlement funds should be disbursed and the
                  timing of such disbursements. Any funds held by us on your
                  behalf will be referred to as your “Settlement Account,” but
                  such funds are held by us and commingled with other Merchants’
                  funds in one or more pooled accounts. These pooled accounts
                  are established in Paytm Labs' name for this purpose. Creation
                  and maintenance of pooled accounts are done at our sole
                  discretion. Paytm Labs has no right, title or interest in any
                  account in which Merchant funds are held.
                </p>
                <p>
                  Funds associated with your Settlement Account will be held by
                  us in a pooled account as described above, but separate from
                  any account used for our corporate funds. We will not and
                  cannot use your funds for our corporate purposes (including
                  the granting of any security or similar interest), will not
                  voluntarily make your funds available to our creditors in the
                  event of bankruptcy or for any other purpose, and will not
                  knowingly permit our creditors to attach to your funds. You
                  will not receive interest or any other earnings on any funds
                  held by Paytm Labs in association with your Settlement
                  Account. As consideration for using the Service, you
                  irrevocably assign to us all rights and legal interests to any
                  interest and/or other earnings or benefits that may accrue or
                  are attributable to Paytm Labs holding your funds in the
                  Settlement Account or Reserve (defined below).
                </p>
                <p>
                  You agree that you have no right to direct the funds in the
                  Settlement Account and that you may not assign any interest or
                  grant any security interest or lien in the Settlement Account
                  to a third party.
                </p>
                <p>
                  Your authorizations set forth herein will remain in full force
                  and effect until your Paytm Labs Payment Account is closed or
                  terminated.
                </p>
                <p>
                  If you carry a negative balance in your Settlement Account for
                  an extended period of time (as defined by us), we may close
                  your Settlement Account, we may terminate the Service provided
                  to you and we may pursue legal action or other collection
                  efforts.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Designated Merchant Bank Account
                </h3>
                <p>
                  You are required to provide information regarding a valid
                  Canadian bank account (“Designated Merchant Bank Account”),
                  and you must authorize us to debit or credit the Designated
                  Merchant Bank Account for amounts owed to you or by you in
                  connection with the Service. You agree that we shall have the
                  right to deduct funds from the Merchant Designated Bank
                  Account to cover any amounts owed by you to either of us and
                  you agree to provide us with a completed pre-authorized debit
                  agreement in the form we request (your “PAD Authorization”).
                </p>
                <h3 className="dib relative w-100 f4 b">Processing Errors</h3>
                <p>
                  We will attempt to fix the processing errors we discover. If
                  the error resulted in your receipt of fewer funds than you
                  were entitled, we will credit your Settlement Account for the
                  difference. If the error results in your receipt of more funds
                  than you were entitled, Paytm Labs will debit the extra funds
                  from your Settlement Account or your Designated Merchant Bank
                  Account. You are responsible for monitoring your transactions
                  and ensuring that our payments to you are correct. You must
                  notify us of any errors in payments made to you within sixty
                  (60) days of the error first appearing on your electronic
                  transaction history. Failure to notify us of a processing
                  error within such sixty (60) days will be deemed a waiver of
                  any right to additional funds as a result of the error. We
                  will only correct transactions that you process incorrectly if
                  you notify us of such an error.
                </p>
                <h3 className="dib relative w-100 f4 b">Reserve</h3>
                <p>
                  At any time and from time to time, we may temporarily suspend
                  or delay payments to you and/or designate an amount of funds
                  that you must maintain in your Settlement Account (“Reserve”)
                  to secure the performance of your payment obligations under
                  this Agreement. We may require a Reserve for any reason,
                  including high chargeback risk or indications of performance
                  problems related to your use of the Service.
                </p>
                <p>
                  The Reserve will be in an amount as reasonably determined by
                  us to cover anticipated chargebacks on a payment card network,
                  disputes with your Customers, returns, unshipped merchandise
                  and/or unfulfilled services or credit risk based on your
                  processing history. The Reserve may be raised, reduced or
                  removed at any time by Paytm Labs, in its sole discretion,
                  based on your payment history, a credit review, the amount of
                  any arbitration award or court judgment against, or otherwise
                  as Paytm Labs may determine or require, including in
                  consultation with, or at the direction of, the Payment
                  Processor or the Bank.
                </p>
                <p>
                  If you do not have sufficient funds in your Reserve, we may
                  fund the Reserve from any funding source associated with your
                  Settlement Account, including the Designated Merchant Bank
                  Account or any amount we owe you, including but not limited to
                  any funds:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>
                    credited to you or your Settlement Account, Designated
                    Merchant Bank Account or any other funding source associated
                    with your Settlement Account,
                  </li>
                  <li>due to you under this Agreement, or</li>
                  <li>
                    available in any account, or other payment instrument
                    registered with us.
                  </li>
                </ol>
                <p>
                  You grant us a security interest in the funds in your
                  Settlement Account and Designated Merchant Bank Account,
                  including any Reserve, and those funds will be available to
                  Paytm Labs for amounts you owe to us. You agree to execute any
                  additional documentation required for us to perfect our
                  security interest in any funds in your Settlement Account,
                  Designated Merchant Bank Account or the Reserve. This security
                  interest survives for as long as there are funds in your
                  Settlement Account, Designated Merchant Bank Account or
                  Reserve; however, it does not apply to any funds for which the
                  grant of a security interest would be prohibited by law. You
                  irrevocably assign to us all rights and legal interests to any
                  interest or other earnings that accrue or are attributable to
                  your Reserve.
                </p>
                <h2 className="dib relative w-100 f3 b">Our Fees</h2>
                <p>
                  You agree to pay our fees (the “Fees”) for use of the Service
                  as described in the Fee Disclosure Box and Other Fee
                  Disclosure Box that are set out at the beginning of this
                  Agreement. We will withhold these Fees from amounts due to you
                  from your Payment Transactions or debit your Settlement
                  Account or your Designated Merchant Bank Account in accordance
                  with your PAD Authorization.
                </p>
                <p>
                  We reserve the right to change our Fees at any time by
                  notifying you at least ninety (90) days in advance of the
                  change. By continuing to use the Service after being notified
                  of a change, you consent to the change in Fees. To withdraw
                  your consent, you must discontinue using the Service. All
                  Fees, charges, and payments collected or paid through the
                  Service are in Canadian dollars.
                </p>
                <h3 className="dib relative w-100 f4 b">Taxes</h3>
                <p>
                  You are responsible for determining any and all taxes
                  assessed, incurred, or required to be collected, paid, or
                  withheld, in connection with your use of the Service
                  (“Taxes”). You are solely responsible for collecting,
                  withholding, reporting and remitting correct any Taxes to the
                  appropriate tax authority. Paytm Labs is not obligated to, nor
                  will we determine whether taxes apply, or calculate, collect,
                  report or remit any Taxes to any tax authority arising from
                  your use of the Service.
                </p>
                <p>
                  Paytm Labs will report payments and other information related
                  to this Service to regulatory or government authorities as
                  required by law.
                </p>
                <h2 className="dib relative w-100 f3 b">D. Use Restrictions</h2>
                <h3 className="dib relative w-100 f4 b">Restricted Use</h3>
                <p>
                  You will not, and will not to allow third-parties, agents,
                  affiliates or designees to:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>
                    Act as a money services business, money transmitter, payment
                    intermediary, aggregator or service bureau or otherwise
                    resell our services on behalf of any third party;
                  </li>
                  <li>
                    Use the Service to handle, process or transmit funds for any
                    third party;
                  </li>
                  <li>
                    Abuse the payment system or violate the Operating
                    Regulations, in the reasonable opinion of the Networks or
                    Paytm Labs;
                  </li>
                  <li>Use the Service to process cash advances;</li>
                  <li>
                    Sell, resell, lease, or the functional equivalent, the
                    Service to a third party;
                  </li>
                  <li>
                    Attempt to create a substitute or similar service through
                    the use of, or access to, the Service;
                  </li>
                  <li>
                    Use the Business with Paytm to export or re-export any
                    Service(s) or content thereon or any portion thereof, in
                    violation of the export control laws and regulations of
                    Canada or any other country; or
                  </li>
                  <li>
                    Attempt to create a substitute or similar service through
                    the use of, or access to, the Service;
                  </li>
                  <li>
                    Use the Services, or a component of the Services, in a
                    manner not authorized by Paytm Labs or outside of the
                    intended use of the Service.
                  </li>
                </ol>
                <p>
                  In addition, you agree not to, and not to allow third-parties,
                  agents, affiliates or designees to, access or use the Service:
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>
                    Except as required in connection with the Business with
                    Paytm Service, to post, store, e-mail, upload, scan or
                    otherwise provide to Paytm Labs, either directly or
                    indirectly, otherwise confidential information to the
                    Service, including, without limitation, any third party’s
                    payment information, or your or any third party’s social
                    security, social insurance, or alternate government-issued
                    identity numbers, non-public phone numbers, or non-public
                    email addresses. This prohibition includes but is not
                    limited to the posting or storing of images or scans
                    containing such prohibited information;
                  </li>
                  <li>
                    To post, transmit, or distribute content that is false,
                    misleading, unlawful, obscene, indecent, lewd, pornographic,
                    hateful, abusive, inflammatory, or that violates the rights
                    of others;
                  </li>
                  <li>
                    To violate, or encourage the violation of, the legal rights
                    of others;
                  </li>
                  <li>
                    For any illegal, unlawful, invasive, infringing, defamatory
                    or fraudulent purpose;
                  </li>
                  <li>
                    To collect, or attempt to collect, personal information
                    about users or third parties without their consent, or using
                    such information except as necessary to use the Service;
                  </li>
                  <li>
                    To send unsolicited offers, advertisements, proposals, or
                    junk mail or spam to others;
                  </li>
                  <li>
                    To, intentionally or otherwise, distribute viruses, worms,
                    Trojan horses, corrupted files, hoaxes or other items of a
                    destructive or deceptive nature;
                  </li>
                  <li>
                    To interfere with the use of the Service, or the equipment
                    used to provide the Service, by customers, or other
                    authorized users;
                  </li>
                  <li>
                    To alter, disable, interfere with or circumvent any aspect
                    of the Service;
                  </li>
                  <li>
                    To violate the security of Business with Paytm or attempt to
                    gain unauthorized access to any Service, or Paytm Labs'
                    computer systems or networks connected to any server
                    associated with Paytm Labs; or
                  </li>
                  <li>
                    To attempt to reverse engineer Business with Paytm or any
                    other Service or any component thereof.
                  </li>
                </ol>
                <h3 className="dib relative w-100 f4 b">
                  Unauthorized or Illegal Use
                </h3>
                <p>
                  In addition, you will use commercially reasonable efforts to
                  prevent unauthorized use of the Service and to immediately
                  disable and terminate any unauthorized use. You are
                  responsible for all use of your Paytm Payment Account and your
                  User ID and other access information (e.g. passwords, if any).
                  You will promptly notify Paytm Labs of any unauthorized use
                  of, or access to, the Service of which you become aware.
                </p>

                <p>
                  Paytm Labs may suspend, disable, or change your Paytm Payment
                  Account or User ID (or password) at any time if Paytm Labs
                  believes that any of your access information has been
                  compromised, that you or someone using your Paytm Payment
                  Account is a threat to the integrity or security of any
                  Service(s), or if Paytm Labs has another reasonable basis for
                  doing so.
                </p>

                <p>
                  Paytm Labs may refuse to settle any transaction that you
                  submit to us if we believe that the transaction is in
                  violation of this Agreement, or exposes you, other Business
                  with Paytm users, our Payment Processor, the Bank or us to
                  potential harm. Harm includes, but is not limited to, any risk
                  of loss or damage, fraud and other criminal acts.
                </p>

                <p>
                  If we have reason to suspect unauthorized, illegal, or
                  criminal activity, we will share information about you, your
                  Paytm Payment Account, your Settlement Account and any of your
                  transactions with law enforcement as necessary and as
                  permitted by law.
                </p>

                <h3
                  id="prohibited-payments-activities"
                  className="dib relative w-100 f4 b"
                >
                  Prohibited Payment Activities
                </h3>
                <ul className="list-iems-doc">
                  <li>Adult content</li>
                  <li>Airlines</li>
                  <li>
                    Alimony, child support, or other court-ordered payments
                  </li>
                  <li>Bail bonds</li>
                  <li>Bankruptcy lawyers</li>
                  <li>Bidding fee auctions (a.k.a. penny auctions)</li>
                  <li>Business physically located outside Canada</li>
                  <li>Buyers clubs, discount clubs or membership clubs</li>
                  <li>Chain letters</li>
                  <li>Cheque cashing, or payment for a dishonored cheque</li>
                  <li>Computer repair or maintenance services</li>
                  <li>Cruise lines</li>
                  <li>Credit counseling or credit repair agencies</li>
                  <li>
                    Credit protection or identity theft protection services
                  </li>
                  <li>Counterfeit goods</li>
                  <li>Debt collection, consolidation, or reduction services</li>
                  <li>Digital currencies</li>
                  <li>Direct marketing of subscription offers</li>
                  <li>Distressed property sales and marketing</li>
                  <li>Door to door sales</li>
                  <li>
                    Drugs, drug paraphernalia, or items that may represent them
                  </li>
                  <li>
                    Equities (including stocks, bonds, or any other ownership
                    position in a corporation)
                  </li>
                  <li>Factoring, liquidators, bailiffs, bail bondsmen</li>
                  <li>
                    Financial services, such as cash advances, bill payment,
                    loans, prepaid cards, wire transfers, or sales of money
                    orders or foreign currency
                  </li>
                  <li>
                    Firm selling “get rich quick” schemes, business
                    opportunities, investment opportunities, mortgage
                    consulting, real estate purchase with No Money Down,
                    mortgage reductions services, credit repair or protection,
                    etc.
                  </li>
                  <li>
                    Gambling or betting, including lottery tickets, casino
                    gaming chips, fantasy football, memberships on
                    gambling-related internet sites
                  </li>
                  <li>
                    Goods or services to be delivered more than four (4) months
                    in the future, with the intention of gaining return on
                    investment
                  </li>
                  <li>
                    Hate, violence, racial intolerance, or the financial
                    exploitation of a crime
                  </li>
                  <li>Infomercial merchants</li>
                  <li>Internet auctions</li>
                  <li>Internet pharmacies or pharmacy referral sites</li>
                  <li>
                    Inbound or outbound telemarketing businesses including lead
                    generation businesses
                  </li>
                  <li>Licensed or franchised goods or services</li>
                  <li>Medical equipment</li>
                  <li>Multi-level marketing businesses</li>
                  <li>Obscene or pornographic items</li>
                  <li>Pharmaceuticals, including medical marijuana</li>
                  <li>Political parties</li>
                  <li>Prepaid phone cards or phone services</li>
                  <li>
                    Prostitution, escort services, massage parlors, and related
                    sexual services
                  </li>
                  <li>Real estate or motor vehicle sales</li>
                  <li>Rebate or upsell programs</li>
                  <li>Scrip-dispensing terminal</li>
                  <li>
                    Telecommunications (including wireless, cable, satellite,
                    wireline, and ISP)
                  </li>
                  <li>Timeshares, timeshare resales and related marketing</li>
                  <li>Tobacco, cigarettes, e-cigarettes, or cigar stores</li>
                  <li>
                    Travel industry (including car rental, lodging, and other
                    travel tour operators)
                  </li>
                  <li>
                    Unlawful activities or items, or activities or items that
                    encourage, promote, facilitate others regarding the same
                  </li>
                  <li>
                    Violent acts or activities or items that encourage, promote,
                    facilitate others regarding the same
                  </li>
                  <li>Weapons, ammunition or other accessories</li>
                  <li>Weight loss programs</li>
                </ul>
                <h3 className="dib relative w-100 f4 b">
                  Discounts and Surcharging
                </h3>
                <p>
                  In Canada, the Networks’ Operating Regulations permit
                  merchants to provide discounts for different methods of
                  payments and to provide differential discounts among different
                  payment card networks. Charging your Customers a surcharge to
                  pay with a credit card is generally not permitted and, in
                  future, may only be done in compliance with the Operating
                  Regulations of each Network.
                </p>
                <h2 className="dib relative w-100 f3 b">
                  E. Transactions and Settlement
                </h2>
                <h3 className="dib relative w-100 f4 b">
                  Accepted Forms Of Payment
                </h3>
                <p>
                  Payment Cards: Paytm Labs supports most domestic credit,
                  debit, prepaid or gift cards bearing Visa, MasterCard or
                  Interac trademarks. In addition, Paytm Labs supports most
                  international cards bearing these trademarks. We may add or
                  remove support for certain payment cards at any time without
                  prior notice. You agree to accept the types of payment cards
                  you selected during the onboarding process.
                </p>

                <p>
                  EFT Bank Payments: Paytm Labs permits you to accept electronic
                  EFT payments from a Customer’s bank account via pre-authorized
                  debit or Interac e-transfer. The clearing and settlement of
                  bank payments is controlled and managed by Payments Canada and
                  member banks. All bank payments that we process for you are
                  subject to Payments Canada’s rules and the Operating
                  Regulations of Interac.
                </p>

                <p>
                  <div className="black">Pre-authorized Debits (PAD)</div>
                  You understand that your customers' consent is required to
                  debit their bank account and that we will provide a form of
                  PAD agreement to provide to your customers to obtain such
                  consent. You will be the originator of each PAD and we will
                  initiate each PAD on your behalf and will credit the debited
                  funds to your Settlement Account. Note that PADs are processed
                  through the Payments Canada system and may require up to 5
                  business days to clear and an additional 2 business days to be
                  credited into your Settlement Account. You are responsible for
                  informing your Customers of the processing time for PADs.
                </p>

                <p>
                  <div className="black">Interac e-Transfer</div>
                  Where your customer chooses to pay by Interac e-Transfer, you
                  understand that your customer will transfer funds to us on
                  your behalf and that we will credit such funds in your
                  Settlement Account.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Payment Transactions
                </h3>
                <p>
                  Payment Transactions are indicated as Payment, Recurring
                  Payment or Refund, and are submitted to Paytm Labs
                  automatically and immediately when the customer completes the
                  Payment Transaction.
                </p>
                <p>
                  “Payment” indicates that a transaction has cleared and the
                  funds are available in your Settlement Account. If Paytm Labs
                  determines that the transaction is related to a restricted or
                  prohibited business or activity or that the transaction is the
                  result of fraudulent activity, Paytm Labs may reverse or
                  refund the transaction at any time.
                </p>

                <p>
                  “Recurring Payment” You may use some Services to receive
                  recurring or subscription payments from your Customers. If you
                  use the Service to submit these recurring or subscription
                  payments, you agree to comply with applicable Laws, including
                  clearly informing Customers in advance of submitting the
                  initial Payment that they will be charged on an ongoing basis
                  and explaining the method for unsubscribing or cancelling
                  their recurring billing or subscription.
                </p>

                <p>
                  “Refund” indicates that a transaction has been reversed, in
                  whole or in part, or cancelled. This could be due to you
                  issuing a refund at a Customer’s request, or due to us
                  initiating a chargeback. At any time, generally up to 90 days,
                  or longer as defined by the Networks, from the transaction
                  date, a transaction may be disputed by the Customer. Any such
                  disputes resolved in favour of the Customer may result in a
                  reversal or chargeback of the disputed transaction. We also
                  have a right to chargeback a Payment Transaction if the
                  transaction does not comply with this Agreement or otherwise
                  in accordance with the Operating Regulations. You can contact
                  our support team (through your Paytm Payment Account) for more
                  information on refunds and chargebacks. Although payments are
                  refunded, the removal of an authorization on a Customer credit
                  card or a return of funds to a Customer bank account may not
                  be immediate and Paytm Labs cannot guarantee funds
                  availability within a specific timeframe. You understand that
                  as the Merchant you will be responsible and liable for any
                  refunds, chargebacks and returns of Payments.
                </p>

                <p>
                  Upon receipt of a Payment Transaction by Paytm Labs, Paytm
                  Labs immediately submits the Payment Transaction to the
                  Payment Processor, following which, the Customer’s chosen
                  payment method (payment card or bank account) account will be
                  charged. You agree that the Customer’s payment obligation to
                  you is fulfilled at the time of our submission of the Payment
                  Transaction to our Payment Processor. You agree not to attempt
                  to collect or otherwise seek payment from the Customer
                  directly. You agree that the Customer is a third-party
                  beneficiary of the preceding two sentences.
                </p>

                <p>
                  Paytm Labs reserves the right to limit or restrict transaction
                  size or volume at any time. We will consider a variety of
                  factors in making this decision and will make this
                  determination at our sole discretion.
                </p>

                <h3 className="dib relative w-100 f4 b">Payout Schedule</h3>
                <p>
                  Subject to our rights under this Agreement to withhold,
                  set-off or otherwise deduct funds from your Settlement Account
                  balance or your Designated Merchant Bank Account, funds
                  credited to your Settlement Account will be transferred by us
                  to your Designated Merchant Bank Account according to the
                  transfer schedule displayed in your Paytm Payment Account.
                </p>
                <p>
                  Settlements by us to your Designated Merchant Bank Account may
                  be limited or delayed based on your perceived risk and history
                  with Paytm Labs. We will consider a variety of factors in
                  making this decision and will make this determination at our
                  sole discretion. Should Paytm Labs need to conduct an
                  investigation or resolve any pending dispute related to your
                  Settlement Account or the Service provided to you, Paytm Labs
                  defer payout or restrict access to your funds for the entire
                  time it takes us to do so.
                </p>

                <p>
                  All settlements to Merchants are subject to review for risk
                  and compliance purposes and can be delayed or postponed at
                  Paytm Labs' sole discretion.
                </p>

                <h2 className="dib relative w-100 f3 b">F. Security</h2>
                <h3 className="dib relative w-100 f4 b">Privacy</h3>
                <p>
                  Your privacy is very important to us. By accepting this
                  Agreement, you confirm that you have read, understood and
                  accepted our Privacy Policy.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Paytm Labs' Security
                </h3>
                <p>
                  We have implemented technical and organizational measures
                  designed to secure your personal information from accidental
                  loss and from unauthorized access, use, alteration or
                  disclosure. However, we cannot guarantee that unauthorized
                  third parties will never be able to defeat those measures or
                  use your personal information for improper purposes. You
                  acknowledge that you provide your personal information at your
                  own risk.
                </p>
                <p>
                  If you discover a security-related issue, you agree to inform
                  us of the issue immediately by contacting{' '}
                  <a className="blue" href="mailto:merchantsupport@paytm.ca">
                    merchantsupport@paytm.ca
                  </a>
                  , with Attention to "Paytm Labs Security Team" with your
                  merchant ID from your registered merchant email. You also
                  agree not to disclose the issue until Paytm Labs has addressed
                  it, except that you may disclose the issue where required by
                  law or contract.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Cardholder Data Security
                </h3>
                <p>
                  “Cardholder Data” is information associated with a payment
                  card, such as account number, expiration date, and CVV / CVC.
                </p>
                <p>
                  If you handle, transmit, or store any Cardholder Data in
                  connection with your use of the Service or the Paytm Labs API,
                  you agree to comply at all times with the Payment Card
                  Industry Data Security Standards (“PCI DSS”). Further, you
                  agree to certify such compliance and provide documentation in
                  accordance with the Operating Regulations, or when asked by
                  Paytm Labs to do so. You also agree that you will use only PCI
                  compliant service providers in connection with the storage,
                  processing, or transmission of Cardholder Data.
                </p>
                <p>
                  You are fully responsible for the security of data (including
                  but not limited to Cardholder Data) on your website or
                  otherwise in your possession or control. You agree to comply
                  with all applicable laws and rules in connection with your
                  collection, security and dissemination of any personal,
                  financial, or transaction information.
                </p>
                <p>
                  Unless you receive the express consent of your Customer, you
                  may not retain, track, monitor, store, disclose or otherwise
                  use Cardholder Data except for the transaction for which it
                  was given.
                </p>

                <h2 className="dib relative w-100 f3 b">
                  G. Roles and Responsibilities
                </h2>
                <h3 className="dib relative w-100 f4 b">Paytm Labs' Role</h3>
                <p>
                  Paytm Labs provides data processing services for Merchants.
                  Paytm Labs is a Payment Service Provider (“PSP”) and not a
                  bank or a financial entity. We do not offer banking or
                  financial services.
                </p>
                <p>
                  As a PSP, Paytm Labs collects, analyzes and relays information
                  generated in connection with payments between Customers and
                  Merchants. You authorize Paytm Labs to provide this
                  information to the Payment Processer and the Bank in order for
                  the Bank to facilitate payments from Customers to you through
                  the Networks. The Bank will settle all Payment Transactions
                  with Paytm Labs and Paytm Labs will settle all Payment
                  Transactions with you in accordance with this Agreement.
                </p>
                <p>
                  In order to act as a PSP, Paytm Labs must enter into
                  agreements with the Networks, the Payment Processor and the
                  Bank. You are not a third-party beneficiary of these
                  agreements. Each of the Networks is a third-party beneficiary
                  of this Agreement and has beneficiary rights, but not
                  obligations, and may enforce this Agreement against you. Some
                  of these third parties may require a direct agreement with
                  you. If you are required to enter into such an agreement and
                  decline to do so, we may suspend or terminate your Account.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Conversion to Direct Agreements with Payment Processor or
                  Network
                </h3>
                <p>
                  You agree to be bound by the Merchant Services Agreement set
                  forth in Exhibit A to this Agreement if it applies to you. The
                  Merchant Services Agreement applies to you if, for example,
                  you receive more than $1,000,000 in Visa payments from Visa or
                  $1,000,000 in MasterCard payments in a twelve-month period. By
                  accepting this Agreement (by "click-through" or otherwise),
                  you also agree to the terms and conditions of the Merchant
                  Services Agreement, which constitutes a legally binding
                  contract between You, on the one hand, and, if applicable,
                  Paysafe Merchant Services Inc. (the processor), and its
                  designated Member Bank.
                </p>
                <p>
                  Paytm Labs is not a party to the Merchant Services Agreement
                  (Exhibit A) and is not liable to you in respect thereof. By
                  accepting this Agreement and the Merchant Services Agreement
                  you are agreeing to the creation of an account with the
                  Processor for Payment Processing (the “Processor Account”). We
                  reserve the right to change the Payment Processor, subject to
                  the terms of our agreement with Payment Processor.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Customer Service Provided by Merchants
                </h3>
                <p>
                  You are solely responsible for all customer service issues
                  relating to your goods or services, including pricing, order
                  fulfilment, order cancellation by you or the Customer,
                  returns, refunds and adjustments, rebates, functionality and
                  warranty, technical support and feedback concerning
                  experiences with your personnel, policies or processes. In
                  performing customer service, you will always present yourself
                  as a separate entity from Paytm Labs. If your Customer’s
                  payment is rejected or returned for any reason, Paytm Labs
                  shall not be liable for any fees, including a nonsufficient
                  funds (“NSF”) fee, that you may choose to charge your
                  Customer. Paytm Labs does not permit a Merchant to charge a
                  Customer an electronic NSF fee through the Service. You will
                  cooperate with Paytm Labs to assure that Customers have access
                  to clear customer service information, including an active
                  customer service email address or telephone number.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Refunds Provided by Merchants
                </h3>
                <p>
                  You agree to process returns of and provide refunds and
                  adjustments for goods or services through your Paytm Payment
                  Account in accordance with this Agreement and the Operating
                  Regulations.
                </p>
                <p>The Operating Regulations require that you will:</p>
                <ol className="list-iems-doc" type="1">
                  <li>
                    maintain a fair return, cancellation or adjustment policy;
                  </li>
                  <li>
                    disclose your return or cancellation policy to Customers at
                    the time of purchase,
                  </li>
                  <li>
                    not give cash refunds to a Customer in connection with a
                    payment card sale, unless required by law, and
                  </li>
                  <li>
                    not accept cash or any other item of value for preparing a
                    payment card sale refund.
                  </li>
                </ol>
                <p>
                  The amount of the refund or adjustment must include all taxes
                  required to be refunded and must not exceed the original sales
                  total excepting for any reimbursement to the customer to cover
                  shipping costs for the return of merchandise.
                </p>
                <p>
                  You may process refunds and adjustments through the Service at
                  any time. These refunds and adjustments are subject to this
                  Agreement and the Operating Regulations. If your Settlement
                  Account balance is insufficient to cover the refund, you
                  authorize Paytm Labs to withdraw sufficient funds from your
                  Designated Merchant Bank Account to credit back to your
                  Customer’s account in accordance with your PAD Authorization.
                </p>
                <p>
                  Your refund policies must be the same for all payment methods.
                  When processing a full refund, Paytm Labs will refund the Fees
                  for the transaction so your Customer receives the full
                  purchase amount. If your refund policy prohibits returns or
                  your Customer is dissatisfied with your refund policy, the
                  Customer may chargeback the payment.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Merchant’s Liability for Chargebacks and Returns
                </h3>
                <p>
                  The amount of a payment may be charged back to you and
                  deducted from your Settlement Account or Designated Merchant
                  Bank if
                </p>
                <ol className="list-iems-doc" type="1">
                  <li>it is disputed by a Customer,</li>
                  <li>it is reversed for any reason,</li>
                  <li>
                    it was not authorized or we have any reason to believe that
                    the transaction was not authorized, or
                  </li>
                  <li>
                    it is unlawful, suspicious, or in violation of the terms of
                    this Agreement.
                  </li>
                </ol>
                <p>
                  You are liable for all chargebacks and returns, whether or not
                  the chargeback or return complies with the Operating
                  Regulations.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  Merchant’s Compliance Obligations
                </h3>
                <p>
                  You agree to comply with the Networks’ Operating Regulations
                  and rules applicable to merchants in your use of the Service
                  and all applicable Network Operating Regulations are
                  incorporated y reference into this Agreement. The Networks
                  make excerpts of their respective Operating Regulations
                  available on their websites (including visa.ca, mastercard.ca)
                  and we will use reasonable efforts to make links to current
                  Network Operating Regulations available to you on the Paytm
                  Merchant Services website, but the Operating Regulations may
                  change from time to time without notice to you or us. We will
                  have no liability to you for failing to provide access to the
                  current Operating Regulations, and you remain solely
                  responsible for complying with the current Operating
                  Regulations at all times.
                </p>
                <h3 className="dib relative w-100 f4 b">
                  How Paytm Labs Handles Chargebacks and Returns
                </h3>
                <p>
                  In the event of a disputed transaction, Paytm Labs will
                  withdraw funds for the amount of any chargeback or return and
                  any associated Fees, fines, or penalties assessed by the Bank,
                  the Payment Processor or the Networks. If you do not have
                  sufficient funds in your Settlement Account or Designated
                  Merchant Bank Account, we will have the remedies set forth in
                  the “Our Set-off and Collection Rights” section of this
                  Agreement. If you have pending chargebacks or returns, we may
                  delay or reduce payouts to you.
                </p>

                <p>
                  If Paytm Labs reasonably believes that a chargeback or return
                  is likely with respect to any transaction, we may withhold the
                  amount of the potential chargeback or return from payments
                  otherwise due to you under this Agreement until such time
                  that:
                </p>

                <ol className="list-iems-doc" type="1">
                  <li>
                    a chargeback or return is assessed due to a Customer’s
                    complaint, in which case we will retain and refund the funds
                    through the Bank;
                  </li>
                  <li>
                    the period of time under applicable law or Operating
                    Regulation by which the Customer may dispute that the
                    transaction has expired; or
                  </li>
                  <li>
                    we determine that a chargeback or return on the transaction
                    will not occur.
                  </li>
                </ol>

                <p>
                  If we determine, in our sole discretion, that you are
                  incurring an excessive amount of chargebacks or returns, Paytm
                  Labs may establish controls or conditions governing your
                  Settlement Account and Service, including without limitation,
                  by
                </p>

                <ol className="list-iems-doc" type="1">
                  <li>assessing additional Fees,</li>
                  <li>
                    creating a Reserve in an amount reasonably determined by us
                    to cover anticipated chargebacks and related fees,
                  </li>
                  <li>delaying payouts, and</li>
                  <li>
                    terminating or suspending the Service or closing your Paytm
                    Payment Account.
                  </li>
                </ol>

                <p>
                  You acknowledge that we may be required to report your name to
                  the Bank and/or one or more of the Networks if you experience
                  excessive chargebacks or excessive returns, and you waive any
                  claims you may have as a result of such reporting. You agree
                  to assist us when requested, at your expense, in the
                  investigation of any transactions you have processed through
                  the Service. To that end, you permit us to share information
                  about a chargeback or return with the Customer, the Customer's
                  financial institution, and your financial institution in order
                  to investigate and/or mediate a chargeback. We may request
                  necessary information from you to contest the chargeback or
                  return. If the chargeback or return is contested successfully,
                  we will release the reserved funds to you. If a dispute is not
                  resolved in your favour by the Networks or issuing bank or you
                  choose not to contest the chargeback or return, Paytm Labs may
                  recover the chargeback or returned amount and any associated
                  Fees as described in this Agreement. You acknowledge that your
                  failure to assist us in a timely manner when investigating a
                  transaction, including providing us with the necessary
                  documentation within seven (7) days of our request, may result
                  in an irreversible chargeback. We reserve the right, upon
                  notice to you, to charge a fee for mediating and/or
                  investigating such disputes.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Our Set-off and Collection Rights
                </h3>

                <p>
                  To the extent permitted by law, we may set off against any
                  balances in your Settlement Account and your Designated
                  Merchant Bank Account, or against any amounts due to you, for
                  any obligation, you owe us under this Agreement, including
                  without limitation any chargebacks or returns. All Fees are
                  charged at the time of transaction processing and are first
                  deducted from the transferred or collected funds and
                  thereafter from your Settlement Account and then from your
                  Designated Merchant Bank Account. If you do not have
                  sufficient funds in such accounts, we may collect from any
                  funding source associated with your Settlement Account, or
                  from any other account under your control, or from any funding
                  source associated with such other account, including but not
                  limited to any funds:
                </p>

                <ol className="list-iems-doc" type="1">
                  <li>deposited by you,</li>
                  <li>due to you under this Agreement, or</li>
                  <li>
                    available in your bank account, or other payment instrument
                    registered with the Bank.
                  </li>
                </ol>

                <p>
                  Your failure to pay, in full, amounts that you owe us on
                  demand will be a breach of this Agreement. You will be liable
                  for all costs and expenses incurred by or on behalf of us in
                  association with collection in addition to the amount owed,
                  including without limitation legal fees and expenses,
                  collection agency fees, and interest at the lesser of
                  one-and-one-half percent (1.5%) per month (which corresponds
                  to an annual interest rate of 18%). In its discretion, Paytm
                  Labs may make appropriate reports to credit reporting agencies
                  and law enforcement authorities, and cooperate with them in
                  any resulting investigation or prosecution. You hereby
                  expressly agree that all communication in relation to
                  delinquent accounts will be made by electronic mail or by
                  phone, as provided by you to Paytm Labs. Such communication
                  may be made by Paytm Labs or by anyone on its behalf,
                  including but not limited to a third-party collection agent.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Complaint Handling Process
                </h3>

                <p>
                  If you have a complaint, please contact our customer support
                  team here (or through your Paytm Payment Account).
                </p>

                <p>
                  If you have a complaint in respect of the Code of Conduct for
                  the Credit and Debit Card Industry in Canada, please contact
                  Paytm Labs here.
                </p>

                <p>
                  You also may contact the Financial Consumer Agency of Canada
                  (the “FCAC”) by writing to the address below. You can reach
                  the FCAC at 1-866-461-3222.
                </p>

                <p>
                  Financial Consumer Agency of Canada
                  <br />
                  6th Floor, Enterprise Building
                  <br />
                  427 Laurier Ave. West
                  <br />
                  Ottawa, Ontario K1R 1B9, Canada
                </p>

                <h3 className="dib relative w-100 f4 b">Dormant Accounts</h3>

                <p>
                  If there is no activity in your Settlement Account (including
                  access or Payment Transactions) and we have been unable to
                  transfer the funds to your Designated Merchant Bank Account
                  for the period of time set forth in the applicable unclaimed
                  property laws, and you have a credit balance in your
                  Settlement Account, we may notify you by sending an email to
                  your registered email address. We may also notify you by
                  regular mail. We may give you the option of keeping your
                  Settlement Account open, requesting a transfer to a Designated
                  Merchant Bank Account, or requesting a cheque. If you do not
                  respond to our notice within the time period specified in the
                  notice, we may close your Settlement Account and deal with
                  unclaimed balances in accordance with applicable law.
                </p>

                <h2 className="dib relative w-100 f3 b">H. Termination</h2>

                <h3 className="dib relative w-100 f4 b">Termination</h3>

                <p>
                  If your Paytm Payment Account is terminated for any reason,
                  you agree:
                </p>

                <ol>
                  <li>to continue to be bound by this Agreement,</li>
                  <li>to immediately stop using the Service,</li>
                  <li>
                    that we reserve the right (but have no obligation other than
                    as described in our Privacy Policy) to delete all of your
                    information and Paytm Payment Account data stored on our
                    servers, and
                  </li>
                  <li>
                    that Paytm Labs shall not be liable to you or any third
                    party for termination of access to the Service, deletion of
                    your information or Paytm Payment Account data, or export of
                    your information or Paytm Payment Account data.
                  </li>
                </ol>

                <h3 className="dib relative w-100 f4 b">
                  Your Right to Terminate
                </h3>

                <p>
                  If you choose to terminate this Agreement, you may do so at
                  any time by notifying us that you wish to terminate the
                  Service. Any funds held for you by us in your Settlement
                  Account at the time of termination of the Service, less any
                  applicable Fees, will be paid out to you according to your
                  payout schedule, assuming all payout-related authentication
                  requirements have been fulfilled (for example, you may not
                  close your Paytm Payment Account as a means of evading your
                  payout schedule). If an investigation is pending at the time
                  you close your Paytm Payment Account, we may hold your funds
                  until the completion of such investigation. If you are later
                  determined to be entitled to some or all of the funds in
                  dispute, we will release those funds to you.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Our Right to Terminate
                </h3>

                <p>
                  Upon notice to you, we may terminate this Agreement and
                  terminate the Service for any reason with or without cause. We
                  may choose to terminate providing the Service to you without
                  terminating your other Paytm Labs services. We may also
                  suspend your access to the Service and we may suspend access
                  to your Paytm Payment Account (including the funds in your
                  Settlement Account) if you:
                </p>

                <ol>
                  <li>
                    have violated the terms of Paytm Labs' policies or this
                    Agreement,
                  </li>
                  <li>
                    have been reasonably deemed, in our sole discretion, to pose
                    an unacceptable credit or fraud risk to us, or
                  </li>
                  <li>
                    have provided any false, incomplete, inaccurate, or
                    misleading information or have otherwise engaged in
                    fraudulent or illegal conduct
                  </li>
                </ol>

                <h3 className="dib relative w-100 f4 b">
                  Effect of Termination
                </h3>

                <p>
                  We will not be liable to you for compensation, reimbursement,
                  or damages in connection with any termination or suspension of
                  the Service. Any termination of this Agreement does not
                  relieve you of any obligations to pay any Fees or costs
                  accrued prior to the termination and any other amounts owed by
                  you to us as provided in this Agreement.
                </p>

                <h2 className="dib relative w-100 f3 b">
                  I. Warranties and Limitation of Liability
                </h2>

                <h3 className="dib relative w-100 f4 b">
                  Limitations on Paytm Labs' Responsibility
                </h3>

                <p>
                  Paytm Labs makes no representations or guarantees regarding
                  Merchants or Customers utilizing our Service. Use of our
                  Service in no way represents any endorsement by Paytm Labs or
                  by any Network, of a Merchant’s or Customer’s existence,
                  legitimacy, policies or practices. Paytm Labs does not have
                  control of, or liability for, goods or services that are paid
                  for with the Service.
                </p>

                <p>
                  Paytm Labs is providing a service, but making no claims about
                  the quality of the people using it (even though I’m sure most
                  of you are great people!) or the good/services being sold.
                </p>

                <p>
                  If you operate a charitable organization, you may use Paytm
                  Labs to accept payments by registering as a Merchant. It is
                  the responsibility of the Merchant and specifically not Paytm
                  Labs, to appropriately classify their organization and
                  transactions, issue any required reports and receipts, and
                  make any required tax or other filings. Not all charitable
                  organizations are tax-exempt, and not all contributions to
                  charitable organizations are tax-deductible. Contributors are
                  responsible for verifying the status of organizations to which
                  they donate and reporting their donations correctly for tax
                  and other purposes. Paytm Labs specifically disclaims any
                  liability in this regard.
                </p>

                <p>
                  We may require you to submit proof such as your Canada Revenue
                  Agency determination letter to verify your tax-exempt status.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Representations and Warranties
                </h3>

                <p>You represent and warrant to us that:</p>

                <ol className="list-iems-doc" type="1">
                  <li>
                    you are eligible to register and use the Service and have
                    the right, power, and ability to enter into and perform
                    under this Agreement;
                  </li>
                  <li>
                    the name provided by you when you registered for the Service
                    is your name, or the business name, under which you sell
                    goods and services;
                  </li>
                  <li>
                    each Payment Transaction submitted by you will represent a
                    bona fide sale by you;
                  </li>
                  <li>
                    each Payment Transaction submitted by you will accurately
                    describe the goods and/or services sold and delivered to a
                    customer;
                  </li>
                  <li>
                    you will fulfil all of your obligations to each Customer for
                    which you submit a transaction and will resolve any consumer
                    dispute or complaint directly with the Customer;
                  </li>
                  <li>
                    you and all transactions initiated by you will comply with
                    all federal, provincial, and local laws, rules, and
                    regulations applicable to your business, including any
                    applicable tax laws and regulations and the Operating
                    Regulations of the applicable network;
                  </li>
                  <li>
                    except in the ordinary course of business, no transaction
                    submitted by you through the Service will represent a sale
                    to any principal, partner, proprietor, or owner of your
                    entity;
                  </li>
                  <li>
                    you will not use the Service, directly or indirectly, for
                    any fraudulent undertaking or in any manner so as to
                    interfere with the use of the Service;
                  </li>
                  <li>
                    your use of the Service will be in compliance with this
                    Agreement.
                  </li>
                </ol>
                <p>
                  Paytm Labs makes no representations that the Service is
                  appropriate or available for use in other locations. Those who
                  access or use the Service from other jurisdictions do so of
                  their own volition and are entirely responsible for compliance
                  with all applicable laws of Canada, including but not limited
                  to export and import regulations. You may not use the Service
                  unless you are a resident of Canada. You may not use the
                  Service if you are a foreign person or entity blocked or
                  denied by the Canadian government. Unless otherwise explicitly
                  stated, all materials found on the Service are solely directed
                  to individuals, companies, or other entities located in
                  Canada.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Disclaimer of Warranties by Paytm Labs
                </h3>

                <p>
                  THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE"
                  BASIS. USE OF THE SERVICE IS AT YOUR OWN RISK. TO THE MAXIMUM
                  EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICE IS PROVIDED
                  WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
                  INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
                  NON-INFRINGEMENT. NO ADVICE OR INFORMATION, WHETHER ORAL OR
                  WRITTEN, OBTAINED BY YOU FROM PAYTM LABS OR THROUGH THE
                  SERVICE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED HEREIN.
                  WITHOUT LIMITING THE FOREGOING, PAYTM LABS, ITS PROCESSORS,
                  ITS PROVIDERS, ITS LICENSORS AND THE BANK (AND THEIR
                  RESPECTIVE SUBSIDIARIES, AFFILIATES, AGENTS, DIRECTORS, AND
                  EMPLOYEES) DO NOT WARRANT THAT THE CONTENT IS ACCURATE,
                  RELIABLE OR CORRECT; THAT THE SERVICE WILL MEET YOUR
                  REQUIREMENTS; THAT THE SERVICE WILL BE AVAILABLE AT ANY
                  PARTICULAR TIME OR LOCATION, UNINTERRUPTED OR SECURE; THAT ANY
                  DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE SERVICE IS
                  FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                </p>

                <p>
                  PAYTM LABS DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
                  RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
                  OFFERED BY A THIRD PARTY THROUGH THE SERVICE OR ANY
                  HYPERLINKED WEBSITE OR SERVICE, OR FEATURED IN ANY BANNER OR
                  OTHER ADVERTISING, AND PAYTM LABS WILL NOT BE A PARTY TO OR IN
                  ANY WAY MONITOR ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY
                  PROVIDERS OF PRODUCTS OR SERVICES.
                </p>

                <h3 className="dib relative w-100 f4 b">Indemnification</h3>

                <p>
                  You will indemnify, defend and hold us and our processors and
                  partners harmless (and our and their respective employees,
                  directors, agents, affiliates and representatives) from and
                  against any and all claims, costs, losses, damages, judgments,
                  tax assessments, penalties, interest, and expenses (including
                  without limitation reasonable lawyers’ fees) arising out of
                  any claim, action, audit, investigation, inquiry, or other
                  proceeding instituted by a third party person or entity that
                  arises out of or relates to:
                </p>

                <ol className="list-iems-doc" type="1">
                  <li>
                    Any actual or alleged breach of your representations,
                    warranties, or obligations set forth in this Agreement,
                    including without limitation any violation of our policies
                    or the Operating Regulations;
                  </li>
                  <li>your wrongful or improper use of the Service;</li>
                  <li>
                    Any Payment Transaction submitted by you through the Service
                    (including without limitation the accuracy of any product
                    information that you provide or any claim or dispute arising
                    out of products or services offered or sold by you);
                  </li>
                  <li>
                    your violation of any third-party right, including without
                    limitation any right of privacy, publicity rights or
                    intellectual property rights;
                  </li>
                  <li>
                    your violation of any law, rule or regulation of Canada or
                    any other country; or
                  </li>
                  <li>
                    Any other party's access and/or use of the Service with your
                    unique username, password or other appropriate security
                    code.
                  </li>
                  <li>
                    your use of the Service for dishonest or fraudulent
                    purposes.
                  </li>
                </ol>

                <h3 className="dib relative w-100 f4 b">
                  Limitation of Liabilities and Damages
                </h3>

                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                  SHALL PAYTM LABS, ITS PROCESSORS, SUPPLIERS, LICENSORS,
                  NETWORKS OR THE BANK (OR THEIR RESPECTIVE AFFILIATES, AGENTS,
                  DIRECTORS AND EMPLOYEES) BE LIABLE FOR ANY DIRECT, INDIRECT,
                  PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY
                  DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF
                  PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES, THAT
                  RESULT FROM THE USE OF, INABILITY TO USE, OR UNAVAILABILITY OF
                  THE SERVICE. UNDER NO CIRCUMSTANCES WILL PAYTM LABS BE
                  RESPONSIBLE FOR ANY DAMAGE, LOSS OR INJURY RESULTING FROM
                  HACKING, TAMPERING OR OTHER UNAUTHORIZED ACCESS OR USE OF THE
                  SERVICE OR YOUR ACCOUNT OR THE INFORMATION CONTAINED THEREIN.
                </p>

                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, PAYTM LABS,
                  ITS PROCESSORS, THE NETWORKS AND THE BANK (AND THEIR
                  RESPECTIVE AFFILIATES, AGENTS, DIRECTORS, AND EMPLOYEES)
                  ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS,
                  MISTAKES, OR INACCURACIES OF CONTENT; (II) PERSONAL INJURY OR
                  PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
                  ACCESS TO OR USE OF THE SERVICE; (III) ANY UNAUTHORIZED ACCESS
                  TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
                  INFORMATION STORED THEREIN; (IV) ANY INTERRUPTION OR CESSATION
                  OF TRANSMISSION TO OR FROM THE SERVICE, OR ANY DELAY IN
                  PERFORMING OUR OBLIGATIONS UNDER THIS AGREEMENT, REGARDLESS OF
                  WHETHER THE FAILURE OR DELAY IS CAUSED BY AN EVENT OR
                  CONDITION BEYOND OUR CONTROL; (V) ANY BUGS, VIRUSES, TROJAN
                  HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH THE
                  SERVICE BY ANY THIRD PARTY; (VI) ANY ERRORS OR OMISSIONS IN
                  ANY CONTENT OR FOR ANY LOSS OR DAMAGE INCURRED AS A RESULT OF
                  THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR
                  OTHERWISE MADE AVAILABLE THROUGH THE SERVICE; AND/OR (VII)
                  USER CONTENT OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT
                  OF ANY THIRD PARTY. IN NO EVENT SHALL PAYTM LABS, ITS
                  PROCESSORS, AGENTS, SUPPLIERS, LICENSORS, NETWORKS OR THE BANK
                  (OR THEIR RESPECTIVE AFFILIATES, AGENTS, DIRECTORS, AND
                  EMPLOYEES) BE LIABLE TO YOU FOR ANY CLAIMS, PROCEEDINGS,
                  LIABILITIES, OBLIGATIONS, DAMAGES, LOSSES OR COSTS IN AN
                  AMOUNT EXCEEDING THE AMOUNT OF FEES EARNED BY US IN CONNECTION
                  WITH YOUR USE OF THE SERVICE DURING THE THREE (3) MONTH PERIOD
                  IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM FOR
                  LIABILITY.
                </p>

                <h2 className="dib relative w-100 f3 b">J. General</h2>

                <h3 className="dib relative w-100 f4 b">Business Use Only.</h3>

                <p>
                  Neither party should be held liable for a delay or failure in
                  performance of this Agreement for Services caused by reason of
                  any occurrence of unforeseen event beyond its reasonable
                  control, including but not limited to, acts of God, natural
                  disasters, power failures, server failures, third-party
                  service provider failures or service interruptions, embargo,
                  labour disputes, lockouts and strikes, riots, war, floods,
                  insurrections, legislative changes, and governmental actions.
                  The party so affected by the unforeseen event shall be so
                  excused on a day-to-day basis for the period of time equal to
                  that of the underlying cause of delay.
                </p>

                <h3 className="dib relative w-100 f4 b">Force Majeure.</h3>

                <p>
                  All provisions of these Agreement are, notwithstanding the
                  manner in which they have been grouped together or linked
                  grammatically, severable from each other. If any of these
                  Agreement should be determined to be unenforceable the
                  remaining Agreement shall survive and remain in full force and
                  effect and continue to be binding and enforceable.
                </p>

                <h3 className="dib relative w-100 f4 b">Severance.</h3>

                <p>
                  Except as otherwise set out herein, this Agreement shall in
                  all respects be governed by and interpreted, construed and
                  enforced in accordance with the laws of the Province of
                  Ontario and the laws of Canada applicable therein as applied
                  to agreements entered into and to be performed entirely within
                  Ontario, without regard to its choice of law or conflicts of
                  law principles that would require application of law of a
                  different jurisdiction. The parties hereto irrevocably submit
                  and attorn to the exclusive jurisdiction and venue of the
                  courts of the Province of Ontario, Canada.
                </p>

                <p>
                  You waive all rights to a trial by jury in connection with any
                  legal proceeding or dispute against us. You further agree that
                  any dispute or proceeding which you may bring against us shall
                  be conducted on an individual basis and not a class-wide basis
                  and that any such proceeding or dispute shall not be
                  consolidated with any other dispute or proceeding which might
                  arise between us and any other user.
                </p>

                <h3 className="dib relative w-100 f4 b">Interpretation.</h3>

                <p>
                  The division of this Agreement into sections and the inclusion
                  of section headings contained in this document are for
                  reference purposes only and shall not affect the construction
                  or interpretation of this Agreement. The singular includes the
                  plural, and the plural includes the singular. All references
                  to “herein,” “hereunder,” “hereinabove,” or like words shall
                  refer to this Agreement as a whole and not to any particular
                  section, subsection, or clause contained in this Agreement.
                  The terms “include” and “including” are not limiting.
                  Reference to any agreement or other contract includes any
                  permitted modifications, supplements, amendments, and
                  replacements.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  No Waiver, Remedies.
                </h3>

                <p>
                  No delay or omission to exercise any right or remedy accruing
                  upon any breach or default hereunder (or to insist upon the
                  strict performance in any respect or on any occasion) shall
                  impair any such right or remedy nor be construed as a waiver
                  of any such breach or default or of any similar breach or
                  default thereafter occurring, nor shall any single or partial
                  exercise thereof preclude any other or further exercise
                  thereof or the exercise of any other right or remedy. No
                  waiver (or consecutive waivers) of any single breach or
                  default shall operate or be construed as a waiver of any
                  subsequent breach or default.
                </p>

                <p>
                  The remedies provided in this Agreement are cumulative and not
                  exclusive of any remedies provided to Paytm under Applicable
                  Law.
                </p>

                <h3 className="dib relative w-100 f4 b">Assignment</h3>

                <p>
                  This Agreement and any rights granted hereunder may not be
                  transferred or assigned by you but may be assigned by Paytm
                  Labs without restriction or consent.
                </p>

                <h3 className="dib relative w-100 f4 b">
                  Amendment of Agreement
                </h3>

                <p>
                  Other than in respect of any change in Fees, we reserve the
                  right to modify or add to this Agreement at any time, and to
                  change, delete, discontinue, or impose conditions on any
                  feature or aspect of the Service with notice that we in our
                  sole discretion deem to be reasonable in the circumstances,
                  including but not limited to notice on our website or any
                  other website maintained or owned by us and identified to you.
                  Any use of the Service after our publication of any such
                  changes shall constitute your acceptance of the then-current
                  version of this Agreement. You may not modify or amend this
                  Agreement unless we agree to such modification or amendment in
                  a written instrument signed by a duly authorized
                  representative of Paytm Labs. For the purposes of this
                  section, a written instrument shall expressly exclude
                  electronic communications such as email and electronic notices
                  including facsimiles.
                </p>

                <h3 className="dib relative w-100 f4 b">Survival</h3>

                <p>
                  Any provision that is reasonably necessary to accomplish or
                  enforce the purpose of this Agreement shall survive and remain
                  in effect in accordance with its terms upon the termination of
                  this Agreement.
                </p>

                <h3 className="dib relative w-100 f4 b">Headings</h3>

                <p>
                  The headings used in this Agreement are inserted for
                  convenience only and will not affect the interpretation of any
                  provision.
                </p>

                <h2 className="dib relative w-100 f3 b">
                  Exhibit A: Merchant Services Agreement
                </h2>

                <p>
                  For the latest version of the Merchant Service Agreement that
                  applies as per Section G - please see here:
                </p>

                <p>
                  <a
                    className="blue"
                    href="https://www.paysafe.com/fileadmin/content/agreements/Peoples_Trust_Terms_and_Conditions.pdf"
                  >
                    https://www.paysafe.com/fileadmin/content/agreements/Peoples_Trust_Terms_and_Conditions.pdf
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default TermsOfService
